module.exports = __webpack_public_path__ + "media/images/lb/178-d0112d2bdda2ca3010b5a9b0c6a6c9fc.svg";